<!-- 投放数据统计——投手维度 -->
<template>
<div id="pitcher">
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;">投放数据统计——投手维度</div>
		<!-- <div style="margin-top: 20px;display: flex;align-items: center;width: 180px;position: sticky;left: 30px;z-index: 5;">
			<div style="font-size: 16px;margin-right: 15px;">已选择{{selected_number}}项</div>
			<a-button type="danger" @click="showDelModal">删除</a-button>
		</div> -->
	</div>
	
	<div style="margin-top: 10px;">
		<!-- 表头 -->
		<div class="table-th"  :style="{'width': table_scroll_width + 'px'}">
			
			<div  class="table-th-cell-sticky" style="display: flex;align-items: center;">
				
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px',}">
					
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px',}">
					
					{{rableTitle[1].title}}
				</div>
				
			</div>

			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell"  v-if="index > 1"
				:style="{'width':item.width + 'px'}">{{item.title}}</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="item.id" class="table-td" :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;" :style="{'height': item.height + 'px'}">
				
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px',}">
					{{item.id}}
				</div>
				<!-- 名字 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px',}">
					{{item.name}}
				</div>
				
			</div>
			
			<!-- 昨日消耗 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px',}">
				{{item.yesterday_used}}
			</div>
			<!-- 昨日回收 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px',}">
				{{item.yesterday_left}}
			</div>
			<!-- 昨日ROI -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px',}">
				{{item.yesterday_roi}}
			</div>
			<!-- 本周消耗 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px',}">
				{{item.this_week_used}}
			</div>
			<!-- 本周回收 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px',}">
				{{item.this_week_left}}
			</div>
			<!-- 本周ROI -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px',}">
				{{item.this_week_roi}}
			</div>
			<!-- 本月消耗 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px',}">
				{{item.this_month_used}}
			</div>
			<!-- 本月回收 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[9].width + 'px',}">
				{{item.this_month_left}}
			</div>
			<!-- 本月ROI -->
			<div  class="table-td-cell" :style="{'width':rableTitle[10].width + 'px',}">
				{{item.this_month_roi}}
			</div>
			<!-- 上月消耗 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[11].width + 'px',}">
				{{item.last_month_used}}
			</div>
			<!-- 上月回收 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[12].width + 'px',}">
				{{item.last_month_left}}
			</div>
			<!-- 上月ROI -->
			<div  class="table-td-cell" :style="{'width':rableTitle[13].width + 'px',}">
				{{item.last_month_roi}}
			</div>
		</div>
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
	</div>
	
	<a-modal v-model="del_modal" title="确认删除？" okType="danger" width="560px"
	  okText="删除" cancelText="取消"
	  @ok="delOk" :confirmLoading="del_loading">
	    <div style="display: flex;align-items: center;flex-wrap: wrap;">
			<div v-for="(item,index) in delShowData" :key="index" style="width: 165px;margin-bottom: 10px;" class="">id：{{item.id}} —— {{item.name}}</div>
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { userCountData } from '@/request/api'

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

export default {
	name: 'pitcher',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:70, type:"id", sort_:90,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"名字",width:110, type:"name", sort_:89,},
				{title:"昨日消耗",width:110, type:"yesterday_used", sort_:87,},
				{title:"昨日回收",width:110, type:"yesterday_left", sort_:86,},
				{title:"昨日ROI",width:110, type:"yesterday_roi", sort_:85,},
				{title:"本周消耗",width:110, type:"this_week_used", sort_:84,},
				{title:"本周回收",width:110, type:"this_week_left", sort_:83,},
				{title:"本周ROI",width:110, type:"this_week_roi", sort_:82,},
				{title:"本月消耗",width:120, type:"this_month_used", sort_:81,},
				{title:"本月回收",width:120, type:"this_month_left", sort_:80,},
				{title:"本月ROI",width:120, type:"this_month_roi", sort_:79,},
				{title:"上月消耗",width:140, type:"last_month_used", sort_:78,},
				{title:"上月回收",width:140, type:"last_month_left", sort_:77,},
				{title:"上月ROI",width:140, type:"last_month_roi", sort_:76,},
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600,
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			
			// 多选测试
			checkedList: defaultCheckedList,
			indeterminate: false,
			checkAll: false,
			plainOptions,
			
			selected_number: 0, // 已选数量
			del_modal: false, // 删除弹窗控制
			del_loading: false, // 弹窗删除按钮的加载状态
			delShowData: [], // 选中的要删除的内容
		}
	},
	mounted(){
		let that = this
		that.search_button_loading = true
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		userCountData().then(res=>{
			console.log("请求结果",res.data.data.list)
			that.search_button_loading = false
			if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
				that.$message.success('数据获取成功');
				let data = res.data.data.list || []
				data.forEach(res=>{
					res.checked = false
				})
				that.tableShowData = data
			}
			else {
				if(res.data.code === 401){ // 未登录
					localStorage.removeItem("access_token");
					that.$router.replace({name: 'login',params: {type:'not_log'}})
				}
				else {
					that.$message.error(`其他错误：${res.data.msg}`);
				}
			}
		})
	},
	methods:{
		// 多选测试
		onChangeCheckbox(checkedList,index) {
			let that = this
		    that.tableShowData[index].checked = !that.tableShowData[index].checked
			
			let ccc = true 
			let iii = false
			let nnn = 0
			console.log("that.tableShowData",that.tableShowData)
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					nnn = nnn + 1
				}
				if(!res.checked){
					ccc = false
				}
			})
			console.log("ccc",ccc)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			that.selected_number = nnn
		},
		onCheckAllChange(e) {
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				that.selected_number = 0
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
				})
				that.selected_number = that.tableShowData.length
				that.indeterminate = false
				that.checkAll = true
			}
			
		},
		
		// 显示删除弹窗
		showDelModal(){
			if(this.selected_number > 0){
				let that = this
				this.del_modal = true
				let d_data = []
				that.tableShowData.forEach(res=>{
					if(res.checked){
						let obj = {
							id: res.id,
							name: res.name
						}
						d_data.push(obj)
					}
				})
				that.delShowData = d_data
				console.log("d_data",d_data);
			}
		},
		// 删除弹窗确认
		delOk(e){
			console.log(e)
			this.del_loading = true
		},
		
	}
}
</script>

<style scoped>
.page-title {
	text-align: left;
	font-weight: 500;
	font-size: 24px;
}

</style>